<template>
  <v-container fluid class="mt-4" id="registration-form--container">
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-title>{{ $t("form.labels.loading") }}</v-card-title>
        <v-card-text>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-stepper v-model="step" id="registration-form--stepper" alt-labels>
      <v-stepper-header>
        <v-toolbar width="100%" elevation="0" v-if="pageType !== 'TBM'">
          <v-card-title v-if="currentUser">
            <v-icon large left> mdi-account-circle </v-icon>
            {{ currentUser.username }}
          </v-card-title>
          <v-card-title v-else v-html="$t('label.loginInfo')"> </v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            :href="logoutUrl"
            v-if="currentUser"
          >
            <v-icon left>mdi-logout</v-icon>
            Logout
          </v-btn>
          <v-btn color="primary" class="mr-4" :href="loginUrl" v-else>
            <v-icon left>mdi-login</v-icon>
            Login
          </v-btn>
        </v-toolbar>
        <v-stepper-step :complete="step > 1" step="1">{{
          $t("form.labels.information").toUpperCase()
        }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2">{{
          $tc("form.labels.registration", 1).toUpperCase()
        }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3">{{
          $t("form.labels.contact").toUpperCase()
        }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 4" step="4">{{
          $t("form.labels.invoice").toUpperCase()
        }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 5" step="5">{{
          $t("form.labels.summary").toUpperCase()
        }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 6" step="6">{{
          $t("form.labels.payment").toUpperCase()
        }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="7">{{
          $t("form.labels.confirmation").toUpperCase()
        }}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <information-step @onContinue="handleMultiple" />

        <participant-step
          :multiple="multipleRegistration"
          @onContinue="
            step = 3;
            updateContactData();
          "
          @onBack="step--"
          :pageType="pageType"
        />

        <contact-step
          :multiple="multipleRegistration"
          @onContinue="
            step = 4;
            updateInvoiceData();
          "
          @onBack="step--"
        />
        <invoice-step
          :multiple="multipleRegistration"
          @onContinue="step = 5"
          @onBack="step--"
        />

        <summary-step @onContinue="step = 6" @onBack="step--" />

        <payment-step
          @onContinue="onPaymentContinue"
          @onBack="step--"
          :pageType="pageType"
        />

        <final-step />
      </v-stepper-items>
    </v-stepper>
    <v-snackbar v-model="errorSnackbar" :multi-line="true" color="primary" top>
      {{ $t("payment.error") }}

      <v-btn dark text @click="errorSnackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ContactStep from "./RegistrationForm/ContactStep";
import FinalStep from "./RegistrationForm/FinalStep";
import InformationStep from "./RegistrationForm/InformationStep";
import InvoiceStep from "./RegistrationForm/InvoiceStep";
import ParticipantStep from "./RegistrationForm/ParticipantStep";
import PaymentStep from "./RegistrationForm/PaymentStep";
import SummaryStep from "./RegistrationForm/SummaryStep";

export default {
  components: {
    ContactStep,
    FinalStep,
    InvoiceStep,
    InformationStep,
    PaymentStep,
    ParticipantStep,
    SummaryStep,
  },
  async created() {
    await this.getCurrentUser();
  },
  mounted() {
    this.step = this.nameToStep();
    this.stepToName();
    this.toggleLoading(false);
    this.setPageType(this.pageType);
  },
  props: ["pageType"],
  data() {
    return {
      step: null,
      multipleRegistration: true,
      errorSnackbar: false,
    };
  },
  methods: {
    ...mapActions([
      "setPageType",
      "getCurrentUser",
      "updateContactData",
      "updateInvoiceData",
      "resetRegistration",
      "saveRegistration",
      "toggleLoading",
    ]),
    handleMultiple(/*isMultiple*/) {
      // this.multipleRegistration = isMultiple;
      this.step++;
    },
    stepToName() {
      if (
        (this.step === null || this.step === 1) &&
        !this.$route.path.endsWith("information")
      ) {
        this.$router.push("/information");
      } else if (
        this.step === 2 &&
        !this.$route.path.endsWith("registration")
      ) {
        this.$router.push("/registration");
      } else if (this.step === 3 && !this.$route.path.endsWith("contact")) {
        this.$router.push("/contact");
      } else if (this.step === 4 && !this.$route.path.endsWith("invoice")) {
        this.$router.push("/invoice");
      } else if (this.step === 5 && !this.$route.path.endsWith("overview")) {
        this.$router.push("/overview");
      } else if (this.step === 6 && !this.$route.path.endsWith("payment")) {
        this.$router.push("/payment");
      } else if (this.step === 7 && !this.$route.path.endsWith("complete")) {
        this.$router.push("/complete");
      }
    },

    nameToStep() {
      if (
        this.$route.path.endsWith("information") ||
        this.$route.path.endsWith("/")
      ) {
        return 1;
      } else if (this.$route.path.endsWith("registration")) {
        return 2;
      } else if (this.$route.path.endsWith("contact")) {
        return 3;
      } else if (this.$route.path.endsWith("invoice")) {
        return 4;
      } else if (this.$route.path.endsWith("overview")) {
        return 5;
      } else if (this.$route.path.endsWith("payment")) {
        return 6;
      } else if (this.$route.path.endsWith("complete")) {
        return 7;
      }
    },

    async onPaymentContinue() {
      await this.saveRegistration();
      this.step = 7;
      // if (!res.err) {
      //   this.step = 7;
      // } else {
      //   this.errorSnackbar = true;
      // }
    },
  },

  watch: {
    $route(next, prev) {
      if (prev.path === "/complete") {
        this.step = 1;
      } else {
        this.step = this.nameToStep();
      }
    },
    step() {
      this.$nextTick(() => {
        this.$vuetify.goTo("#registration-form--container", { offset: 54 });
      });
      this.stepToName();
    },
  },

  computed: {
    ...mapGetters(["currentUser", "loading"]),
    loginUrl() {
      return `/sso/login?redirectUrl=${window.location.pathname}#${this.$route.path}`;
    },
    logoutUrl() {
      return `/sso/logout?redirectUrl=${window.location.pathname}#${this.$route.path}`;
    },
  },
};
</script>
<style lang="scss">
#registration-form--stepper {
  width: 100%;
}

@media (max-width: 465px) {
  .v-stepper {
    .v-stepper__step {
      flex-basis: auto !important;
    }
    .v-divider {
      border: unset !important;
    }
  }
}
</style>
